/**
 * Client-side password rules aligned with application policy.
 * @param {string} password
 * @returns {string[]} Human-readable requirement messages for anything not satisfied.
 */
export function getPasswordPolicyErrors(password) {
  const p = password || ''
  const errors = []
  if (p.length < 14) errors.push('At least 14 characters.')
  if (!/[a-z]/.test(p)) errors.push('At least one lowercase letter (a-z).')
  if (!/[A-Z]/.test(p)) errors.push('At least one uppercase letter (A-Z).')
  if (!/\d/.test(p)) errors.push('At least one number (0-9).')
  if (!/[^a-zA-Z0-9\s]/.test(p)) {
    errors.push('At least one special character (for example !@#$%^&*).')
  }
  return errors.length >= 1 ? ['Your password must contain at least 14 characters, and at least one Uppercase, lowercase, numbers, and special characters (e.g. !@#$%^&*)'] : []
}
